export interface CustomerInfo {
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  RewardsNumber: string;
}

export const persistCustomerInfo = (value: CustomerInfo) => {
  localStorage.setItem("customer", JSON.stringify(value));
};

export const retrievePersistedCustomerInfo = (): CustomerInfo | null => {
  const storedCustomer = localStorage.getItem("customer");

  if (!storedCustomer) {
    return null;
  }
  // Parse the JSON string into an object
  const customer = JSON.parse(storedCustomer);
  return customer;
};
